import React from 'react';
import Breadcrumbs from "../components/Breadcrumbs";
import AboutText from "../components/AboutText";
import {Helmet} from "react-helmet";

const About = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>О нас - Holz-City</title>
                <meta
                    name="description"
                    content="Высококачественные пиломатериалы для строительства, отделки и ремонта."
                />
            </Helmet>
            <Breadcrumbs/>
            <AboutText/>
        </div>
    );
};

export default About;